// extracted by mini-css-extract-plugin
export default {"root":"IconFishing_root__4SG-w"};